import styled from 'styled-components';
import { breakpoint } from '@carvana/helios-layout';
import { text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';

const FAQSectionWrapper = styled.div`
  padding: 64px 24px;
  margin: auto;
  max-width: 551px;
  display: flex;
  flex-direction: column;

  ${breakpoint.sm`
    padding: 80px 32px;
    max-width: 959px;
  `}

  ${breakpoint.md`
    max-width: 1272px;
    padding: 80px 84px;
    flex-direction: row;
    justify-content: space-between;
  `}

  &.video-experiment {
    padding: 0px 24px;
    margin-bottom: 56px;

    ${breakpoint.sm`
      margin-bottom: 160px;
  `}
  }
`;

const FAQHeader = styled.div`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 16px;

  ${breakpoint.md`
    ${heading['3Xl']};
  `}

  &.capitalize {
    text-transform: capitalize;
  }
`;

const SubText = styled.p`
  ${body.md};
  color: ${text.default};
  margin-bottom: 20px;

  ${breakpoint.md`
    margin-bottom: 36px;
  `}
`;

const FAQAccordionWrapper = styled.div`
  margin-bottom: 40px;

  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  ${breakpoint.md`
    width: 732px;
  `}
`;

const FAQButtonWrapper = styled.a`
  margin: 0 auto;

  ${breakpoint.md`
    display: none;
  `}

  &.desktop-only {
    display: none;

    ${breakpoint.md`
      display: block;
      margin: 0;
    `}
  }

  button {
    width: 327px;

    ${breakpoint.sm`
      width: 182px;
    `}
  }
`;

const TextContainer = styled.div`
  ${breakpoint.md`
    max-width: 360px;
  `}
`;

export {
  FAQSectionWrapper,
  FAQHeader,
  FAQAccordionWrapper,
  FAQButtonWrapper,
  SubText,
  TextContainer
};
